import React, { useEffect } from 'react'
import { Text, Textarea } from '@cinch-labs/design-system'
import styles from './booking-notes.module.css'
import { CarMaintenanceStepWrapper } from '../car-maintenance-step-wrapper/car-maintenance-step-wrapper'
import { useMaintenanceContext } from '../../context/maintenance-context'
import { datadogRum } from '@datadog/browser-rum'

export const BookingNotes: React.FC = () => {
  const {
    dispatch,
    notes: contextNotes,
    step,
    serviceOptionsSelectedNames,
  } = useMaintenanceContext()

  const [notes, setNotes] = React.useState<string>('')

  useEffect(() => {
    if (contextNotes) {
      setNotes(contextNotes)
    }
  }, [contextNotes])

  const handleContinue = () => {
    datadogRum.addAction('Cinch Servicing: Notes Added', {
      step,
      page: window.location.pathname,
      serviceOptionsSelectedNames,
      notesLength: notes.length,
      hasNotes: notes.length > 0,
    })

    dispatch({ type: 'SET_NOTES', notes })
  }

  return (
    <CarMaintenanceStepWrapper
      title="Add booking notes"
      description="Is there anything specific you’d like us to check?"
      onContinue={handleContinue}
    >
      <div className={styles.container}>
        <div className={styles.formGroup}>
          <Text
            element="label"
            fontSizeFixed="s"
            className={styles.label}
            htmlFor="booking-notes"
          >
            Booking notes (optional)
          </Text>

          <Textarea
            id="booking-notes"
            className={styles.textarea}
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            placeholder="Enter any specific concerns or notes..."
            rows={6}
            maxLength={300}
          />
        </div>
      </div>
    </CarMaintenanceStepWrapper>
  )
}
